import React from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Container,
} from '@mui/material';
import { Lock, Home } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export function Unauthorized() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            textAlign: 'center',
            width: '100%',
          }}
        >
          <Lock
            color="warning"
            sx={{ fontSize: 60, mb: 2 }}
          />
          
          <Typography variant="h4" gutterBottom>
            Acesso Negado
          </Typography>
          
          <Typography variant="body1" color="text.secondary" paragraph>
            Você não tem permissão para acessar esta página. Entre em contato com o administrador se precisar de acesso.
          </Typography>

          <Button
            variant="contained"
            startIcon={<Home />}
            onClick={() => navigate('/')}
            sx={{ mt: 2 }}
          >
            Voltar ao Início
          </Button>
        </Paper>
      </Box>
    </Container>
  );
}